// extracted by mini-css-extract-plugin
export default {"svgButton":"SvgButton_svgButton__kQEXP","buttonSpan":"SvgButton_buttonSpan__R2Ywo","buttonChat":"SvgButton_buttonChat__qiXLj"};